__turbopack_context__.v({
  "error-code": "error-information-visid-module-scss-module__Yxf1Aq__error-code",
  "error-container": "error-information-visid-module-scss-module__Yxf1Aq__error-container",
  "error-desc": "error-information-visid-module-scss-module__Yxf1Aq__error-desc",
  "error-icon": "error-information-visid-module-scss-module__Yxf1Aq__error-icon",
  "error-read-more": "error-information-visid-module-scss-module__Yxf1Aq__error-read-more",
  "error-title": "error-information-visid-module-scss-module__Yxf1Aq__error-title",
  "retry-button": "error-information-visid-module-scss-module__Yxf1Aq__retry-button",
  "return-link": "error-information-visid-module-scss-module__Yxf1Aq__return-link",
  "separator": "error-information-visid-module-scss-module__Yxf1Aq__separator",
});
